import PropTypes from "prop-types"
import React, { useState } from "react"
import { Form, Input, FormFeedback, Label } from "reactstrap"

import LoadingButton from "../../components/Common/LoadingButton"
import AuthLayout from "../../components/Common/AuthLayout"
import PreferredCitySelect from "../../components/Common/PreferredCitySelect"

import { Link } from "react-router-dom"
import withRouter from "../../components/Common/withRouter"

import { toast, Bounce } from "react-toastify"
import { post } from "../../api/axios"
import { toastApiError } from "../../helpers/apiError"
import endpoints from "../../api/endpoints"
import * as Yup from "yup"
import { useFormik } from "formik"

const RequestInvite = props => {
  document.title = " Request An Invite | AMOK . EARTH"

  const navigate = props.router?.navigate
  const location = props.router?.location
  const [isSubmitting, setIsSubmitting] = useState(false)
  const prefillEmail =
    typeof location?.state?.email === "string" ? location.state.email : ""

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      firstName: "",
      lastName: "",
      email: prefillEmail,
      preferredCity: "",
      reason: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Please enter your email"),
      firstName: Yup.string().required("Please enter your First Name"),
      lastName: Yup.string().required("Please enter your Last Name"),
      preferredCity: Yup.string().required("Please enter your Preferred City"),
      reason: Yup.string().required("Please enter your Reason"),
    }),
    onSubmit: async values => {
      if (isSubmitting) return
      setIsSubmitting(true)
      try {
        const payload = {
          first_name: values.firstName,
          last_name: values.lastName,
          email: values.email,
          city_id: values.preferredCity,
          reason: values.reason,
        }
        const response = await post(endpoints.requestInvite, payload)

        if (response?.data?.success) {
          toast.success(response?.data?.message, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          })
          navigate("/login")
        } else if (response?.response?.data) {
          toastApiError(response)
        }
      } catch (error) {
        toastApiError(error)
      } finally {
        setIsSubmitting(false)
      }
    },
  })

  return (
    <AuthLayout
      compact
      title="Request an Invite"
      subtitle="Join the community of creative professionals"
    >
      <Form
        className="auth-page__form auth-page__form--hide-scrollbar"
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <div className="auth-page__field">
          <Label className="auth-page__label">First Name</Label>
          <Input
            name="firstName"
            className="form-control"
            placeholder="Enter your first name"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.firstName || ""}
            invalid={
              !!(validation.touched.firstName && validation.errors.firstName)
            }
          />
          {validation.touched.firstName && validation.errors.firstName ? (
            <FormFeedback type="invalid">
              {validation.errors.firstName}
            </FormFeedback>
          ) : null}
        </div>

        <div className="auth-page__field">
          <Label className="auth-page__label">Last Name</Label>
          <Input
            name="lastName"
            className="form-control"
            placeholder="Enter your last name"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.lastName || ""}
            invalid={
              !!(validation.touched.lastName && validation.errors.lastName)
            }
          />
          {validation.touched.lastName && validation.errors.lastName ? (
            <FormFeedback type="invalid">
              {validation.errors.lastName}
            </FormFeedback>
          ) : null}
        </div>

        <div className="auth-page__field">
          <Label className="auth-page__label">Email</Label>
          <Input
            name="email"
            className="form-control"
            placeholder="Enter your email address"
            type="email"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.email || ""}
            invalid={!!(validation.touched.email && validation.errors.email)}
          />
          {validation.touched.email && validation.errors.email ? (
            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
          ) : null}
        </div>

        <div className="auth-page__field">
          <Label className="auth-page__label">Preferred City</Label>
          <PreferredCitySelect
            variant="auth"
            loadFromApi
            label=""
            placeholder="Select a city"
            value={validation.values.preferredCity}
            onChange={next => validation.setFieldValue("preferredCity", next)}
            onBlur={() => validation.setFieldTouched("preferredCity", true)}
            error={
              validation.touched.preferredCity && validation.errors.preferredCity
                ? validation.errors.preferredCity
                : ""
            }
          />
        </div>

        <div className="auth-page__field">
          <Label className="auth-page__label">Reason</Label>
          <Input
            name="reason"
            className="form-control"
            placeholder="Tell us why you want to join..."
            rows={4}
            type="textarea"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.reason || ""}
            invalid={!!(validation.touched.reason && validation.errors.reason)}
          />
          {validation.touched.reason && validation.errors.reason ? (
            <FormFeedback type="invalid">
              {validation.errors.reason}
            </FormFeedback>
          ) : null}
        </div>

        <LoadingButton loading={isSubmitting}>Submit Request</LoadingButton>

        <p className="auth-page__footer-text">
          Already have an account?{" "}
          <Link to="/login" className="auth-page__footer-link">
            Login
          </Link>
        </p>
      </Form>
    </AuthLayout>
  )
}

export default withRouter(RequestInvite)

RequestInvite.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}
